/* eslint-disable no-console */
import { z, ZodError } from "zod";

// We've defined here the validations & schema for making sure the env vars ARE correct.
const defaultValidation = z.string().min(1, "Env Var is not defined");
const envSchema = z.object({
  VITE_APP_ENV: defaultValidation,
  VITE_APP_URL: defaultValidation,
  VITE_API_URL: defaultValidation,
  VITE_POST_PURCHASE_SIGNATURE: defaultValidation,
  VITE_GTM_CONTAINER_ID: defaultValidation,
  VITE_GTM_EVENT_PREFIX: defaultValidation,
  VITE_EO_DISPENSARY_SLUG: defaultValidation,
  VITE_EO_CONTACT_NUMBER: defaultValidation,
  VITE_SENTRY_DNS_PUBLIC: z.string().nullish(),
  VITE_FORMSORT_PROFILING_ENV: defaultValidation,
  VITE_FORMSORT_PROFILING_CLIENT_LABEL: defaultValidation,
  VITE_FORMSORT_PROFILING_FLOW_LABEL: defaultValidation,
  VITE_FORMSORT_PROFILING_VARIANT_LABEL: defaultValidation,
  VITE_FORMSORT_SURVEY_ENV: defaultValidation,
  VITE_FORMSORT_SURVEY_CLIENT_LABEL: defaultValidation,
  VITE_FORMSORT_SURVEY_FLOW_LABEL: defaultValidation,
  VITE_FORMSORT_SURVEY_VARIANT_LABEL: defaultValidation,
  VITE_FORMSORT_POST_PURCHASE_SURVEY_ENV: defaultValidation,
  VITE_FORMSORT_POST_PURCHASE_SURVEY_CLIENT_LABEL: defaultValidation,
  VITE_FORMSORT_POST_PURCHASE_SURVEY_FLOW_LABEL: defaultValidation,
  VITE_FORMSORT_POST_PURCHASE_SURVEY_VARIANT_LABEL: defaultValidation,
  VITE_SHOPIFY_ACCESS_TOKEN: defaultValidation,
  VITE_SHOPIFY_DOMAIN: defaultValidation,
  VITE_SHOPIFY_API_VERSION: defaultValidation,
  VITE_CAREPLAN_DISCOUNT_CODE: defaultValidation,
  VITE_SURVEY_DISCOUNT_CODE: defaultValidation,
  VITE_SHIPPING_OPTION_CODE_STANDARD: defaultValidation,
  VITE_SHIPPING_OPTION_CODE_2_DAY_DELIVERY: defaultValidation,
  VITE_PERSONIFY_ENABLED: defaultValidation,
  VITE_MAINTENANCE_MODE: defaultValidation,
  VITE_MAINTENANCE_REDIRECT_URL: defaultValidation,
  VITE_MARKETING_SITE_DOMAIN: defaultValidation,
  VITE_SUBSCRIPTION_PROCESSING_TIMEOUT_SECONDS: defaultValidation,
});

type EnvValues = z.infer<typeof envSchema>;

// IDEA: trigger a toast message on dev instead of just a console error
const logEnvError = (errors: ZodError<EnvValues>) => {
  const { _errors, ...formattedErrors } = errors.format();

  console.error("<");
  console.error("ENVIRONMENT VARIABLES ERRORS:");
  console.error("----");
  Object.entries(formattedErrors).forEach(([name, { _errors }]) => {
    const errMsg = _errors.join(", ");
    console.error(`"${name}": ${errMsg}`);
  });
  console.error("----");
  console.error(">");
};

const checkEnv = () => {
  try {
    return envSchema.parse(import.meta.env);
  } catch (errors) {
    if (errors instanceof ZodError) {
      logEnvError(errors as ZodError<EnvValues>);
    }

    // So! We had some validation errors
    // let's just make sure the shape of the object is what we are expecting
    return Object.fromEntries(
      Object.keys(envSchema.shape).map((key) => {
        return [key, import.meta.env[key] || ""];
      }),
    ) as EnvValues;
  }
};

export const env = checkEnv();
